import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { Col, Row } from "antd";

import MyTvButton from "./MyTvButton";
import Arrow from "../icons/rightArrow.svg";

const StyledFarmingCardCard = styled.div`
  width: 361px;
  min-height: 350px;
  background: transparent
    linear-gradient(
      324deg,
      ${({ theme }) => theme.sfcBg1} 0%,
      ${({ theme }) => theme.sfcBg2} 100%
    )
    0% 0% no-repeat padding-box;
  border-radius: 15px;
  opacity: 1;
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding-bottom: 32px;
  font-family: Circe;
`;

const StyledFarmingCardCardHeader = styled.div`
  align-items: center;
  width: 80%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding-top: 32px;
`;

const StyledFarmingCardContent = styled.div`
  width: 80%;
  opacity: 1;
  display: flex;
  align-items: center;
  flex-direction: column;
`;

const StyledFarmingCardTitle = styled.div`
  width: 100%;
  text-align: left;
  font: normal normal bold 30px/45px Circe;
  letter-spacing: 0px;
  color: ${({ theme }) => theme.fg1};
  opacity: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const StyledContentWrapper = styled.div`
  list-style: none;
  margin-left: 20px;
  padding-left: 24px;
  border-left: 3px solid #71c0eb;
  font: normal normal bold 18px/26px Circe;
  letter-spacing: 0px;
  color: ${({ theme }) => theme.fg1};
  opacity: 1;
  margin-top: 10px;
`;

const ContentItem = styled.li`
  font: normal normal 18px/26px Circe;
  letter-spacing: 0px;
  color: ${({ theme }) => theme.fg1};
  opacity: 1;
  margin-bottom: 16px;
`;

const StyledTvlWrapper = styled(Row)`
  background-color: ${({ theme }) => theme.sfcTvlWrapper};
  border-radius: 10px;
  color: ${({ theme }) => theme.fg1};
`;

const StyledTitleCardFarming = styled.h5`
  margin-bottom: 0;
  color: ${({ theme }) => theme.fg1};
  font: normal normal bold 30px/45px Circe;
`;

export default function FarmingCard({
  title,
  apy,
  apr,
  rewards,
  tvl,
  textButton,
  onBtnClick,
  icon1,
  icon2,
  loading,
  style,
  className,
}) {

  return (
    <StyledFarmingCardCard style={style} className={className}>
      <StyledFarmingCardCardHeader>
        <div style={{ marginBottom: 16, width: "100%" }}>
          <img
            src={icon1}
            alt=""
            style={{
              width: 55,
              objectFit: "cover",
              opacity: 1,
            }}
          />
          <img
            src={icon2}
            alt=""
            style={{
              width: 55,
              objectFit: "cover",
              opacity: 1,
              marginLeft: -15,
            }}
          />
        </div>
        <Row style={{ padding: 0, width: "100%" }}>
          <Col style={{ width: "100%" }}>
            <StyledFarmingCardTitle>
              <StyledTitleCardFarming>{title}</StyledTitleCardFarming>
            </StyledFarmingCardTitle>
          </Col>
        </Row>
      </StyledFarmingCardCardHeader>

      {/* Content */}
      <StyledFarmingCardContent>
        <Row style={{ marginBottom: "5px", width: "100%" }}>
          <Col style={{ width: "100%" }}>
            <StyledContentWrapper>
              <ContentItem>
                <b>APY: {apy}</b>
              </ContentItem>
              <ContentItem>
                <b>APR: {apr}</b>
              </ContentItem>
              <ContentItem
                style={{ font: "normal normal 300 18px/26px Circe" }}
              >
                Rewards: {rewards} MYTV/block
              </ContentItem>
            </StyledContentWrapper>
          </Col>
        </Row>
        <StyledTvlWrapper
          style={{ padding: "16px", marginBottom: "5px", width: "100%" }}
        >
          <Col>TVL:</Col>
          <Col style={{ marginLeft: "auto" }}>{tvl}</Col>
        </StyledTvlWrapper>
        <Row style={{ marginBottom: "5px", marginTop: "25px" }}>
          <Col>
            <MyTvButton
              style={{ width: "225px" }}
              iconUrl={Arrow}
              onClick={onBtnClick}
              loading={loading}
            >
              {textButton}
            </MyTvButton>
          </Col>
        </Row>
      </StyledFarmingCardContent>
    </StyledFarmingCardCard>
  );
}
FarmingCard.propTypes = {
  title: PropTypes.string,
  apy: PropTypes.string,
  apr: PropTypes.string,
  rewards: PropTypes.string,
  tvl: PropTypes.string,
  textButton: PropTypes.string,
  onBtnClick: PropTypes.func,
  icon1: PropTypes.string,
  icon2: PropTypes.string,
  loading: PropTypes.bool,
  style: PropTypes.any,
  className: PropTypes.string,
};
